module.exports = __webpack_public_path__ + "static/img/login_layer_bg.fd20bbf.png";